const items = {
	reportType: [
		{
			id: 0,
			name: "report.agent.reportType.all",
		},
		{
			id: 1,
			name: "report.agent.reportType.separateRegion",
		},
		{
			id: 2,
			name: "report.agent.reportType.life",
		},
		{
			id: 3,
			name: "report.agent.reportType.vehicle",
		},
	],
	reportTypeInsuran: [
		{
			id: 1,
			name: "report.agent.reportType.life",
		},
		{
			id: 2,
			name: "report.agent.reportType.vehicle",
		},
	],
	reportTypeInsuranSummary: [
		// {
		// 	id: 3,
		// 	name: "report.summary.reportType.packageSummary",
		// },
		{
			id: 1,
			name: "report.summary.reportType.monthSummary",
		},
		{
			id: 2,
			name: "report.summary.reportType.regionSummary",
		},
		{
			id: 4,
			name: "report.summary.reportType.agentSummary",
		}
	],
	reportTypeInsuranClame: [
		{
			id: 1,
			name: "report.clame.reportType.provine",
		},
		{
			id: 2,
			name: "report.clame.reportType.monthOfYear",
		},
		{
			id: 3,
			name: "report.clame.reportType.region",
		},
		{
			id: 4,
			name: "report.clame.reportType.agent",
		}
	],
	region: [
		{
			id: '',
			name: "report.vehicle.reportType.all",
		},
		{
			key: "north",
			name: "report.agent.region.north",
		},
		{
			key: "center",
			name: "report.agent.region.center",
		},
		{
			key: "south",
			name: "report.agent.region.south",
		},
	],
	reportTypeVehicle: [
		{
			id: 0,
			name: "report.vehicle.reportType.all",
		},
		{
			id: 1,
			name: "report.vehicle.reportType.separateRegion",
		},
		{
			id: 2,
			name: "report.vehicle.reportType.province",
		}
	],
}

export default items;